/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_ALL_DRUG_LIST = 'GET_ALL_DRUG_LIST';
export const GET_DRUG_FAMILY = 'GET_DRUG_FAMILY';
export const REMOVE_DRUG_FROM_LIST = 'REMOVE_DRUG_FROM_LIST';
export const GET_NDC_DETAILS = 'GET_NDC_DETAILS';
export const VIEW_DRUG_SECTION = 'VIEW_DRUG_SECTION';
export const DRUG_FAMILY_DETAILS = 'DRUG_FAMILY_DETAILS';
export const SAVE_DRUG_FAMILY = 'SAVE_DRUG_FAMILY';
export const SAVE_DRUG_SEQ = 'SAVE_DRUG_SEQ';
export const LINK_DRUG_FIELDS = 'LINK_DRUG_FIELDS';
export const ROW_HIGH_LIGHT = 'ROW_HIGH_LIGHT';
export const BUTTON_ENABLE= 'BUTTON_ENABLE';
export const SAVE_DRUGFAMILY_VO = 'SAVE_DRUGFAMILY_VO';
export const SELECT_NDC_PARAM= 'SELECT_NDC_PARAM';
export const VIEW_DRUG_DETAIL_MODAL = 'VIEW_DRUG_DETAIL_MODAL';